<div class="flex">
	<app-anchor type="static" url=".." class="mr-2"
		><h2>APS Intake</h2></app-anchor
	>
	<h2 class="flex-1">/ Edit {{ _title() }} broker</h2>
</div>
<app-container type="dark" class="mt-2">
	<app-create-employee-side-form
		[minify]="false"
		(onSubmit)="_onSubmit($event)"
		(onCancel)="onCancel()"
		checkboxLabel="Same as Brokerage"
		[employee]="brokerage?.broker"
		[company]="brokerage"
	>
	</app-create-employee-side-form>
</app-container>
